import { createSelector } from 'reselect';
import { RootState } from 'store';
import { MarketplaceServiceCategory } from 'types/Marketplace';
import { SessionBusinessArea } from 'types/OnlineBooking';

export const getServicesState = (state: RootState) => state.services;

export const getServices = createSelector(
    (state: RootState) => state.services,
    services => services.services
);

export const getBusinessAreas = createSelector(
    getServicesState,
    services => services.businessAreas
);

export const getHasTrainingAtFacility = createSelector(getBusinessAreas, businessAreas =>
    businessAreas.some(area => area.id === 'training' && area.hasService && area.trainingAtFacility)
);

export const getHasWalkingAtFacility = createSelector(getBusinessAreas, businessAreas =>
    businessAreas.some(area => area.id === 'walking' && area.hasService && area.walkingAtFacility)
);

export const getHasDentalService = createSelector(getBusinessAreas, businessAreas =>
    businessAreas.some(area => area.id === 'dental' && area.hasService)
);

export const getHasWalkingInHome = createSelector(getBusinessAreas, businessAreas =>
    businessAreas.some(area => area.id === 'walking' && area.hasService && area.walkingInHome)
);

export const getHasWalkingService = createSelector(getBusinessAreas, businessAreas =>
    businessAreas.some(area => area.id === 'walking' && area.hasService)
);

export const getHasTrainingInHome = createSelector(getBusinessAreas, businessAreas =>
    businessAreas.some(area => area.id === 'training' && area.hasService && area.trainingInHome)
);

export const getHasTrainingService = createSelector(getBusinessAreas, businessAreas =>
    businessAreas.some(area => area.id === 'training' && area.hasService)
);

export const getHasInHomeByArea: Record<SessionBusinessArea, (state: RootState) => boolean> = {
    [MarketplaceServiceCategory.WALKING]: getHasWalkingInHome,
    [MarketplaceServiceCategory.TRAINING]: getHasTrainingInHome
};

export const getEvaluationServices = createSelector(
    (state: RootState) => state.services,
    services =>
        services.services.filter(
            service => service.businessArea === MarketplaceServiceCategory.EVALUATION
        )
);
